import { useInterval } from 'react-use';
import { pageStore } from '~/pages/strategy_center_admin/pageStore';
export function useRefreshMeLoginState(props) {
    useInterval(() => {
        pageStore.me.refreshMeLoginState();
    }, props.refreshInterval >= 0 ? props.refreshInterval : 1000 * 60 * 5);
}
